import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

const DecisionComplete = ({ decisionData }) => {
    if (!decisionData) return null;

    const styles = `
        .decision-complete-wrapper {
            margin-bottom: 2rem;
        }

        .decision-complete-content {
            padding: 2rem;
            background-color: #f9fafb;
            border-radius: 0.5rem;
            border: 1px solid #e5e7eb;
        }

        .decision-markdown h1 {
            font-size: 1.5rem;
            font-weight: 700;
            color: #F57C00;
            margin-top: 2rem;
            margin-bottom: 1rem;
            padding-bottom: 0.5rem;
            border-bottom: 2px solid #FF9800;
            text-transform: uppercase;
            letter-spacing: 0.05em;
        }
        
        .decision-markdown h1:first-child {
            margin-top: 0;
        }
        
        .decision-markdown h2 {
            font-size: 1.25rem;
            font-weight: 600;
            color: #1f2937;
            margin-top: 1.5rem;
            margin-bottom: 0.75rem;
            text-transform: uppercase;
        }
        
        .decision-markdown h3 {
            font-size: 1.125rem;
            font-weight: 600;
            color: #374151;
            margin-top: 1rem;
            margin-bottom: 0.5rem;
        }
        
        .decision-markdown p {
            color: #374151;
            line-height: 1.8;
            margin-bottom: 1rem;
            text-align: justify;
        }
        
        .decision-markdown strong {
            color: #1f2937;
            font-weight: 600;
        }
        
        .decision-markdown em {
            color: #4b5563;
            font-style: italic;
        }
        
        .decision-markdown ul, .decision-markdown ol {
            margin-left: 1.5rem;
            margin-bottom: 1rem;
            color: #374151;
        }
        
        .decision-markdown li {
            margin-bottom: 0.5rem;
            line-height: 1.7;
        }
        
        .decision-markdown blockquote {
            border-left: 4px solid #F57C00;
            padding-left: 1rem;
            margin: 1rem 0;
            color: #4b5563;
            font-style: italic;
            background-color: #fff3e0;
            padding: 1rem;
            border-radius: 0.375rem;
        }
        
        .decision-markdown code {
            background-color: #f3f4f6;
            padding: 0.125rem 0.25rem;
            border-radius: 0.25rem;
            font-size: 0.875rem;
            color: #1f2937;
        }
        
        .decision-markdown pre {
            background-color: #f3f4f6;
            padding: 1rem;
            border-radius: 0.5rem;
            overflow-x: auto;
            margin: 1rem 0;
        }
        
        .decision-markdown hr {
            border: none;
            border-top: 2px solid #e5e7eb;
            margin: 2rem 0;
        }
        
        /* Style spécial pour les décisions finales */
        .decision-markdown p:has(strong:first-child) {
            background-color: #fff3e0;
            border-left: 4px solid #F57C00;
            padding: 1rem;
            border-radius: 0.375rem;
            margin: 1rem 0;
        }
        
        /* En-têtes de documents juridiques */
        .decision-markdown > p:first-of-type {
            text-align: center;
            font-weight: 600;
            color: #F57C00;
            margin-bottom: 1.5rem;
            font-size: 1.125rem;
        }

        /* Tables pour les documents juridiques */
        .decision-markdown table {
            width: 100%;
            border-collapse: collapse;
            margin: 1rem 0;
        }

        .decision-markdown th {
            background-color: #fff3e0;
            color: #1f2937;
            font-weight: 600;
            padding: 0.75rem;
            text-align: left;
            border-bottom: 2px solid #F57C00;
        }

        .decision-markdown td {
            padding: 0.75rem;
            border-bottom: 1px solid #e5e7eb;
        }

        .decision-markdown tr:hover {
            background-color: #fef3c7;
        }

        .no-content-text {
            color: #6b7280;
            font-style: italic;
            padding: 1rem;
            background-color: #f9fafb;
            border-radius: 0.5rem;
            text-align: center;
        }

        /* Support pour le mode sombre si nécessaire */
        @media (prefers-color-scheme: dark) {
            .decision-complete-content {
                background-color: #1f2937;
                border-color: #374151;
            }

            .decision-markdown p,
            .decision-markdown li {
                color: #d1d5db;
            }

            .decision-markdown h2,
            .decision-markdown h3,
            .decision-markdown strong {
                color: #f3f4f6;
            }

            .decision-markdown blockquote {
                background-color: rgba(245, 124, 0, 0.1);
                color: #e5e7eb;
            }

            .decision-markdown code,
            .decision-markdown pre {
                background-color: #374151;
                color: #f3f4f6;
            }
        }
    `;

    return (
        <>
            <style>{styles}</style>
            <div id="decision_complet" className="decision-complete-wrapper">
                {decisionData.decision_complet || decisionData.decision_markdown ? (
                    <div className="decision-complete-content">
                        <div className="decision-markdown">
                            {decisionData?.decision_markdown ? (
                                <ReactMarkdown remarkPlugins={[remarkGfm]}>
                                    {decisionData.decision_markdown}
                                </ReactMarkdown>
                            ) : (
                                <ReactMarkdown remarkPlugins={[remarkGfm]}>
                                    {decisionData.decision_complet}
                                </ReactMarkdown>
                            )}
                        </div>
                    </div>
                ) : (
                    <p className="no-content-text">
                        Le texte complet de la décision n'est pas disponible.
                    </p>
                )}
            </div>
        </>
    );
};

export default DecisionComplete;